export * from "./update-dataset-value"
export * from "./with-props-validation"

/**
 * Defer importing a def view function until it's called
 *
 * There are some limitations in webpack around dynamic expressions, and so we
 * need to have the view base be a known path like `../`
 *
 * https://webpack.js.org/guides/migrating/#dynamic-expressions
 *
 * @param {String} path Path to view module (relative to entry root)
 */

function importDeferredView(path) {
  return async (el, props) => {
    const f = await import(`../${path}/index.ts`)
    return f.default(el, props)
  }
}

function importDeferredViewTsx(path) {
  return async (el, props) => {
    const f = await import(`../${path}/index.tsx`)
    return f.default(el, props)
  }
}

function importDeferredViewJs(path) {
  return async (el, props) => {
    const f = await import(`../${path}/index.js`)
    return f.default(el, props)
  }
}

export default {
  openSingleDetail: importDeferredView("shared/open-single-detail"),
  masthead: importDeferredView("shared/masthead"),
  toggle: importDeferredView("shared/toggle"),
  hubspotForms: importDeferredView("shared/hubspot-forms"),
  testimonialCarousel: importDeferredView("shared/testimonial-carousel"),
  ribbon: importDeferredView("shared/ribbon"),
  basicCarousel: importDeferredView("shared/basic-carousel"),
  copyToClipboard: importDeferredView("shared/copy-to-clipboard"),
  dialogModal: importDeferredView("shared/dialog-modal"),
  dropdown: importDeferredView("shared/dropdown"),
  filters: importDeferredView("shared/filters"),
  lazyLoad: importDeferredView("shared/lazy-load"),
  localizedDateTime: importDeferredView("shared/localized-date-time"),
  logoSetRows: importDeferredView("shared/logo-set-rows"),
  panelModal: importDeferredView("shared/panel-modal"),
  salesToggle: importDeferredView("shared/sales-toggle"),
  tableOfContents: importDeferredView("shared/table-of-contents"),
  tabs: importDeferredView("shared/tabs"),
  analyticsLoader: importDeferredView("shared/analytics"),
  analyticsClick: importDeferredView("shared/analytics/analytics-click"),
  indexSearch: importDeferredViewTsx("templates/index-search"),
  globalSearch: importDeferredView("shared/global-search"),
  textSnippetShare: importDeferredView("templates/text-snippet-share"),
  companyValuesList: importDeferredView("templates/company-values-list"),
  backgroundVideoControls: importDeferredView(
    "templates/background-video-controls"
  ),
  packageFeatureToggle: importDeferredView(
    "templates/pricing/package-feature-toggle"
  ),
  currencyToggle: importDeferredView("templates/pricing/currency-toggle"),
  hsHiddenFieldsAssignment: importDeferredView(
    "templates/pricing/hs-hidden-fields-assignment"
  ),
  podcastCloseTranscript: importDeferredView(
    "templates/podcast-close-transcript"
  ),
  productBlock: importDeferredView("templates/product-block"),
  ropiCalculator: importDeferredViewTsx("templates/ropi-calculator"),
  careersListing: importDeferredViewTsx("templates/careers-listing"),
  communityEvents: importDeferredViewTsx("templates/community-events"),
  partnersMarketplaceListing: importDeferredViewTsx(
    "templates/partners-marketplace/partners-listing"
  ),
  partnersHiddenFormFields: importDeferredView(
    "templates/partners-marketplace/partners-form"
  ),
  carousel: importDeferredView("shared/carousel"),
  caseStudyCarousel: importDeferredView("shared/case-study-carousel"),
  counter: importDeferredView("shared/counter"),
  toggleReveal: importDeferredView("shared/toggle-reveal"),
  mouseParallax: importDeferredView("shared/mouse-parallax"),
  enterViewportToggle: importDeferredView("shared/enter-viewport-toggle"),
  wistiaPlayer: importDeferredView("shared/wistia-player"),
  pdfEmbed: importDeferredView("shared/pdf-embed"),
  podcastPlayer: importDeferredView("shared/podcast-player"),
  qualified: importDeferredView("shared/qualified"),
  benchmarkPercentileChart: importDeferredViewJs(
    "shared/benchmarks/benchmark-percentile-chart"
  ),
  benchmarksList: importDeferredViewJs("shared/benchmarks/benchmarks-list"),
  benchmarksSelector: importDeferredViewJs(
    "shared/benchmarks/benchmarks-selector"
  ),
  tennisBanner: importDeferredView("templates/tennis-banner"),
  cultureDrivesPerformance: importDeferredView("templates/campaigns/culture-drives-performance"),
  scrollExpand: importDeferredView("templates/campaigns/emerging-culture-creators/scroll-expand"),
}
